<p-breadcrumb [model]="items" styleClass="header-breadcrumb" [home]="home"></p-breadcrumb>